export default "public/ABBvoice_W_Lt.woff";